import { type FC } from 'react'
import { FormattedMessage } from 'react-intl'

import { IconArrowRight } from '@redteclab/icons'

import { Button } from 'base-ui'

export const MethotrexatPharmacistAdvice: FC = () => (
  <>
    <p className="text-s">
      <FormattedMessage id="qualityIndicator.methotrexat.p" />
    </p>
    <div className="mt-2 flex flex-col gap-3">
      <p className="text-s">
        <FormattedMessage id="qualityIndicator.guideNote" />
      </p>
      <div className="flex flex-col items-start gap-2">
        <Button<'a'>
          endIcon={<IconArrowRight />}
          href="/medikamenten-lexikon/wirkstoff-folsaeure/"
          size="small"
          slots={{ root: 'a' }}
          variant="text"
        >
          <FormattedMessage id="qualityIndicator.guide.folicAcid" />
        </Button>
        <Button<'a'>
          endIcon={<IconArrowRight />}
          href="/medikamenten-lexikon/wirkstoff-methotrexat/"
          size="small"
          slots={{ root: 'a' }}
          variant="text"
        >
          <FormattedMessage id="qualityIndicator.guide.methotrexat" />
        </Button>
      </div>
    </div>
  </>
)
